import { ReactNode } from 'react';

import { Flex, Show } from 'shared';

import { ChallengeProofIcon } from 'features/challenge/components/ProofIcon';
import { ChallengeStatusIcon } from 'features/challenge/components/StatusIcon';
import {
  JournalCardBody,
  JournalCardContainer,
  JournalCardFailReasons,
  JournalCardFooter,
  JournalCardHeader,
  JournalCardText,
  JournalCardTitle,
  JournalCardCreatedAtTime,
  JOURNAL_NOTE_TYPES,
  JournalNote,
  JournalCardMediaList,
  JournalCardMenu,
} from 'features/journal';

type TJournalCard = {
  children: ReactNode;
  note: JournalNote;
  setEditedNote: (item: JournalNote) => void;
  isAuthor: boolean;
};

export const JournalCard = ({
  children,
  note,
  setEditedNote,
  isAuthor,
}: TJournalCard) => {
  const prompt = extractPromptFromChallengeTags(note.challenge?.tags);
  const question = note.content?.question || prompt;
  const answer = note.content?.answer || note.text;

  return (
    <JournalCardContainer>
      <JournalCardHeader>
        <Flex
          justifyContent="flex-start"
          alignItems="center"
          gap="0.5rem"
          width="85%"
        >
          <JournalCardCreatedAtTime date={note.createdAt} />
          {note.noteType === JOURNAL_NOTE_TYPES.PROOF && <ChallengeProofIcon />}
          {Boolean(note.challenge?.status) && (
            <ChallengeStatusIcon status={note.challenge.status} />
          )}
          <JournalCardTitle>{note.challenge?.title}</JournalCardTitle>
        </Flex>
        <JournalCardMenu
          isAuthor={isAuthor}
          noteId={note.noteId}
          onEdit={() => setEditedNote(note)}
          isNoteRead={note.isRead}
        />
      </JournalCardHeader>
      <JournalCardBody>
        <Show when={!isAuthor && !!question}>
          <JournalCardTitle>{question}</JournalCardTitle>
        </Show>
        <Flex justifyContent="space-between" width="100%">
          <JournalCardText text={answer} />
          <JournalCardMediaList mediaList={note.mediaList} />
        </Flex>
        <JournalCardFailReasons reasons={note.challenge?.failReasons} />
      </JournalCardBody>
      <JournalCardFooter>{children}</JournalCardFooter>
    </JournalCardContainer>
  );
};

export const extractPromptFromChallengeTags = (tags?: string[]) => {
  const promptTag = tags?.find((tag) => tag.includes('prompt='));

  return promptTag?.replace('prompt=', '');
};
